type RankableSize = { name?: unknown; sortOrder?: number };

export type SizeSorter = (a: RankableSize, b: RankableSize) => number;

export const isEps = (size: RankableSize): boolean => size.name === 'eps';

export const isRankable = (size: RankableSize): boolean =>
  isEps(size) || typeof size.sortOrder === 'number';

export const defaultSorter: SizeSorter = (a, b) =>
  (a.sortOrder ?? 0) - (b.sortOrder ?? 0);

// Ascending by sortOrder, except that eps outranks every other size whatever
// its own sortOrder.
export const epsSorter: SizeSorter = (a, b) => {
  if (isEps(a) !== isEps(b)) return isEps(a) ? 1 : -1;
  return defaultSorter(a, b);
};
